import { render, staticRenderFns } from "./TaskTemplateForm.vue?vue&type=template&id=2f7248de&scoped=true&"
import script from "./TaskTemplateForm.vue?vue&type=script&lang=js&"
export * from "./TaskTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7248de",
  null
  
)

export default component.exports